import { render } from "./PinGroup.vue?vue&type=template&id=a5402c44&scoped=true"
import script from "./PinGroup.vue?vue&type=script&lang=js"
export * from "./PinGroup.vue?vue&type=script&lang=js"

import "./PinGroup.vue?vue&type=style&index=0&id=a5402c44&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5402c44"]])

export default __exports__